import { useSupabase } from "@/app/supabase-provider";
import useSWR from "swr";

export const useSubscription = () => {
  const { supabase } = useSupabase();

  return useSWR("subscription", async () => {
    const { data: subscription } = await supabase
      .from("subscriptions")
      .select("*, prices(*, products(*))")
      .in("status", ["trialing", "active"])
      .maybeSingle()
      .throwOnError();
    return subscription;
  }, {
    revalidateIfStale: false,
    revalidateOnFocus: false,
    revalidateOnReconnect: false
  });
};

export const useProductWithPrices = () => {
  const { supabase } = useSupabase();

  return useSWR("products", async () => {
    const { data, error } = await supabase
      .from("products")
      .select("*, prices(*)")
      .eq("active", true)
      .eq("prices.active", true)
      .order("metadata->index")
      .order("unit_amount", { foreignTable: "prices" });
    if (error) {
      console.log(error.message);
    }
    return data ?? [];
  });
};

export const useCredit = () => {
  const { supabase } = useSupabase();
  return useSWR("userCredit", async () => {
    const { data } = await supabase
      .from("watcher_user_credits_snapshot")
      .select("*")
      .maybeSingle()
      .throwOnError();
    return data;
  });
}